export default __webpack_public_path__ + "static/icn-vault2-baea92dd5adfb723a136b9ba89425e8d.svg";